import * as React from 'react';
import styles from './index.less';
import { Space } from 'antd';
import { connect } from 'dva';
import { Dispatch } from 'redux';
import { ConnectState, ResourceInfoPageModelState } from '@/models/connect';
import {
  ChangeAction,
  OnUnmount_Page_Action,
  OnMount_Page_Action,
  OnClick_SaveIntroductionBtn_Action,
  OnChange_Labels_Action,
  OnChange_Cover_Action,
  OnClick_EditTitleBtn_Action,
  OnClick_CancelEditTitleBtn_Action,
  OnClick_SaveTitleBtn_Action,
  OnChange_TitleInput_Action,
} from '@/models/resourceInfoPage';
import {
  OnChange_Page_Action,
  OnMount_Page_Action as OnMount_Sidebar_Action,
} from '@/models/resourceSider';
import { RouteComponentProps } from 'react-router';
import { Helmet } from 'react-helmet';
import { FI18n, FUtil } from '@freelog/tools-lib';
import FComponentsLib from '@freelog/components-lib';
import FSkeletonNode from '@/components/FSkeletonNode';
import * as AHooks from 'ahooks';
import FResourceLabelEditor from '@/components/FResourceLabelEditor';
import fMessage from '@/components/fMessage';
import FUploadCover from '@/components/FUploadCover';
import FCoverImage from '@/components/FCoverImage';
import FIcons from '@/components/FIcons';
import FCopyToClipboard from '@/components/FCopyToClipboard';
import { history } from '@@/core/history';
import FPrompt from '@/components/FPrompt';
// import FInput_PinyinSafeTextCounter_MultiLine from '@/components/FInput_PinyinSafeTextCounter_MultiLine';
import FIntroductionInput from '@/components/FIntroductionInput';
import FInput_PinyinSafeTextCounter from '@/components/FInput_PinyinSafeTextCounter';

interface InfoProps extends RouteComponentProps<{ id: string }> {
  dispatch: Dispatch;
  resourceInfoPage: ResourceInfoPageModelState;
}

function Info({ dispatch, resourceInfoPage, match }: InfoProps) {
  const [$isEditing_Introduction, set$isEditing_Introduction, get$isEditing_Introduction] =
    FUtil.Hook.useGetState<boolean>(false);

  AHooks.useMount(async () => {
    dispatch<OnMount_Sidebar_Action>({
      type: 'resourceSider/onMount_Page',
      payload: {
        resourceID: match.params.id,
      },
    });
    dispatch<OnChange_Page_Action>({
      type: 'resourceSider/onChange_Page',
      payload: {
        page: 'info',
      },
    });
    dispatch<OnMount_Page_Action>({
      type: 'resourceInfoPage/onMount_Page',
      payload: {
        resourceID: match.params.id,
        // pageState: 'loading',
      },
    });
  });

  AHooks.useUnmount(async () => {
    await dispatch<OnUnmount_Page_Action>({
      type: 'resourceInfoPage/onUnmount_Page',
    });
  });

  return (
    <>
      <FPrompt
        watch={resourceInfoPage.title_IsEditing || $isEditing_Introduction}
        onOk={(locationHref) => {
          history.push(locationHref);
        }}
      />

      <Helmet>
        <title>{`资源信息 · ${
          resourceInfoPage.resourceInfo?.resourceName || ''
        }  - Freelog`}</title>
      </Helmet>
      {resourceInfoPage.pageState === 'loading' && (
        <div>
          <div style={{ height: 40 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={860} height={38} />
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: 20 }}>
            <FSkeletonNode width={200} height={150} />
            <FSkeletonNode width={460} height={40} />
          </div>
          <div style={{ height: 50 }} />
          <FSkeletonNode width={120} height={22} />
          <div style={{ height: 20 }} />
          <FSkeletonNode width={340} height={38} />
        </div>
      )}

      {!!resourceInfoPage.resourceInfo && resourceInfoPage.pageState === 'loaded' && (
        <div>
          <div style={{ height: 40 }} />

          <div className={styles.block}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <FComponentsLib.FContentText
                // text={'资源授权标识'}
                text={FI18n.i18nNext.t('edit_resource_listing_authid')}
                type={'highlight'}
              />
              <FCopyToClipboard
                text={resourceInfoPage.resourceInfo.resourceName}
                // title={'复制'}
                title={FI18n.i18nNext.t('edit_resource_listing_btn_copy')}
              >
                <FComponentsLib.FTextBtn type={'primary'} style={{ fontSize: 12 }}>
                  {/* 复制 */}
                  {FI18n.i18nNext.t('edit_resource_listing_btn_copy')}
                </FComponentsLib.FTextBtn>
              </FCopyToClipboard>
            </div>
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              // text={'此资源在整个授权系统中的唯一标识符，一旦创建则不能更改。'}
              text={FI18n.i18nNext.t('edit_resource_listing_authid_info')}
              type={'additional2'}
            />
            <div style={{ height: 20 }} />
            <div className={styles.resourceTitle} style={{ justifyContent: 'space-between' }}>
              <FComponentsLib.FContentText
                text={resourceInfoPage.resourceInfo.resourceName}
                type={'normal'}
              />

              <FIcons.FLock style={{ color: '#999', fontSize: 14 }} />
            </div>
          </div>

          <div style={{ height: 5 }} />

          <div className={styles.block}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <FComponentsLib.FContentText
                // text={'资源标题'}
                text={FI18n.i18nNext.t('edit_resource_listing_title')}
                type={'highlight'}
              />

              {resourceInfoPage.title_IsEditing && (
                <Space size={10}>
                  <FComponentsLib.FTextBtn
                    type={'default'}
                    style={{ fontSize: 12 }}
                    onClick={() => {
                      dispatch<OnClick_CancelEditTitleBtn_Action>({
                        type: 'resourceInfoPage/onClick_CancelEditTitleBtn',
                      });
                    }}
                  >
                    {/* 取消 */}
                    {FI18n.i18nNext.t('btn_cancel')}
                  </FComponentsLib.FTextBtn>
                  <FComponentsLib.FTextBtn
                    style={{ fontSize: 12 }}
                    disabled={
                      resourceInfoPage.title_Input === '' ||
                      resourceInfoPage.title_Input.length > 100
                    }
                    type={'primary'}
                    onClick={() => {
                      dispatch<OnClick_SaveTitleBtn_Action>({
                        type: 'resourceInfoPage/onClick_SaveEditTitleBtn',
                        payload: {
                          trigger: 'resource',
                        },
                      });
                    }}
                  >
                    {/* 保存 */}
                    {FI18n.i18nNext.t('btn_save')}
                  </FComponentsLib.FTextBtn>
                </Space>
              )}

              {!resourceInfoPage.title_IsEditing && (
                <FComponentsLib.FTextBtn
                  type={'primary'}
                  style={{ fontSize: 12 }}
                  onClick={() => {
                    dispatch<OnClick_EditTitleBtn_Action>({
                      type: 'resourceInfoPage/onClick_EditTitleBtn',
                    });
                  }}
                >
                  {/* 编辑 */}
                  {FI18n.i18nNext.t('edit_resource_listing_btn_edit')}
                </FComponentsLib.FTextBtn>
              )}
            </div>
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              // text={'标题直接影响商品的搜索曝光机会，建议在标题中加入品牌/内容主旨，例如，《大明风华：明朝人的城市生活》；标题长度不超过100个字符。'}
              text={FI18n.i18nNext.t('edit_resource_listing_title_info')}
              type={'additional2'}
            />
            <div style={{ height: 20 }} />
            {resourceInfoPage.title_IsEditing && (
              <>
                <FInput_PinyinSafeTextCounter
                  value={resourceInfoPage.title_Input || ''}
                  lengthLimit={100}
                  style={{ width: '100%' }}
                  placeholder={FI18n.i18nNext.t('cqr_input_title_hint')}
                  onChangeValue={(v) => {
                    dispatch<OnChange_TitleInput_Action>({
                      type: 'resourceInfoPage/onChange_TitleInput',
                      payload: {
                        value: v,
                      },
                    });
                  }}
                  hasError={resourceInfoPage.title_Error !== ''}
                />
                {resourceInfoPage.title_Error !== '' && (
                  <>
                    <div style={{ height: 5 }} />
                    <div style={{ color: '#EE4040' }}>{resourceInfoPage.title_Error}</div>
                  </>
                )}
              </>
            )}

            {!resourceInfoPage.title_IsEditing && (
              <div className={styles.resourceTitle}>
                <FComponentsLib.FContentText
                  text={
                    resourceInfoPage.resourceInfo.resourceTitle ||
                    resourceInfoPage.resourceInfo.resourceName.split('/')[1] ||
                    ''
                  }
                  type={'normal'}
                />
              </div>
            )}
          </div>

          <div style={{ height: 5 }} />

          <div className={styles.block}>
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.t('rqr_input_resouce_image')}
              type={'highlight'}
            />
            <div style={{ height: 5 }} />
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.t('rqr_input_resouce_image_help')}
              type={'additional2'}
            />
            <div style={{ height: 20 }} />
            <FUploadCover
              onUploadSuccess={(url) => {
                dispatch<OnChange_Cover_Action>({
                  type: 'resourceInfoPage/onChange_Cover',
                  payload: {
                    value: url,
                    trigger: 'resource',
                  },
                });
              }}
              onError={(err) => {
                fMessage(err, 'error');
              }}
            >
              {resourceInfoPage.resourceInfo.coverImages.length === 0 && (
                <a className={styles.FUploadImageChildren}>
                  <FIcons.FCloudUpload />
                  <span>{FI18n.i18nNext.t('upload_image')}</span>
                </a>
              )}

              {resourceInfoPage.resourceInfo.coverImages.length > 0 && (
                <div className={styles.cover}>
                  <FCoverImage
                    src={resourceInfoPage.resourceInfo.coverImages[0]}
                    width={200}
                    style={{ borderRadius: 4 }}
                  />
                  <div className={styles.coverEdit}>
                    <FIcons.FEdit style={{ fontSize: 32 }} />
                    <div style={{ height: 10 }} />
                    <div>{FI18n.i18nNext.t('btn_edit_cover')}</div>
                  </div>
                </div>
              )}
            </FUploadCover>
          </div>

          <div style={{ height: 5 }} />

          <FIntroductionInput
            value={resourceInfoPage.introduction_EditorText}
            title={FI18n.i18nNext.t('resource_short_description')}
            tip={FI18n.i18nNext.t('listing_description_info')}
            btnText={FI18n.i18nNext.t('listing_description_btn')}
            onOK={async (value) => {
              await dispatch<ChangeAction>({
                type: 'resourceInfoPage/change',
                payload: {
                  introduction_EditorText: value,
                },
              });
              await dispatch<OnClick_SaveIntroductionBtn_Action>({
                type: 'resourceInfoPage/onClick_SaveIntroductionBtn',
              });
            }}
            onEditingChange={(isEditing) => {
              set$isEditing_Introduction(isEditing);
            }}
          />

          <div style={{ height: 5 }} />

          <div className={styles.block}>
            <FComponentsLib.FContentText
              text={FI18n.i18nNext.t('resource_tag')}
              type={'highlight'}
            />
            <div style={{ height: 20 }} />

            <FResourceLabelEditor
              value={resourceInfoPage.resourceInfo.tags}
              resourceTypeCode={resourceInfoPage.resourceInfo.resourceTypeCode}
              onChange={(value) => {
                dispatch<OnChange_Labels_Action>({
                  type: 'resourceInfoPage/onChange_Labels',
                  payload: {
                    value: value,
                  },
                });
              }}
            />
          </div>

          <div style={{ height: 100 }} />
        </div>
      )}
    </>
  );
}

export default connect(({ resourceInfoPage }: ConnectState) => ({
  resourceInfoPage: resourceInfoPage,
}))(Info);

// interface IntroductionInputProps {
//   value: string;
//   title?: string;
//   tip?: string;
//   btnText?: string;

//   onOK(value: string): void;

//   onEditingChange?(isEditing: boolean): void;
// }

// export function IntroductionInput({
//   value,
//   title = FI18n.i18nNext.t('edit_exhibit_description'),
//   tip = FI18n.i18nNext.t('listing_description_info'),
//   btnText = FI18n.i18nNext.t('listing_description_btn'),
//   onOK,
//   onEditingChange,
// }: IntroductionInputProps) {
//   const [$isEdit, set$isEdit, get$isEdit] = FUtil.Hook.useGetState<boolean>(false);
//   const [$value, set$value, get$value] = FUtil.Hook.useGetState<string>(value);
//   const [$valueError, set$valueError, get$valueError] = FUtil.Hook.useGetState<string>('');

//   function onEdit() {
//     set$isEdit(true);
//     onEditingChange?.(true);
//     set$value(value);
//   }

//   return (
//     <div className={styles.block}>
//       <div
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'space-between',
//         }}
//       >
//         <FComponentsLib.FContentText text={title} type={'highlight'} />

//         <Space size={10}>
//           {!$isEdit && value !== '' && (
//             <FComponentsLib.FTextBtn
//               style={{ fontSize: 12 }}
//               onClick={() => {
//                 onEdit();
//               }}
//             >
//               {FI18n.i18nNext.t('edit')}
//             </FComponentsLib.FTextBtn>
//           )}
//           {$isEdit && (
//             <>
//               <FComponentsLib.FTextBtn
//                 style={{ fontSize: 12 }}
//                 type='default'
//                 onClick={() => {
//                   set$isEdit(false);
//                   onEditingChange?.(false);
//                 }}
//               >
//                 {FI18n.i18nNext.t('cancel')}
//               </FComponentsLib.FTextBtn>
//               <FComponentsLib.FTextBtn
//                 style={{ fontSize: 12 }}
//                 onClick={() => {
//                   onOK(get$value());
//                   set$isEdit(false);
//                   onEditingChange?.(false);
//                 }}
//                 disabled={$value.length > 200}
//               >
//                 {FI18n.i18nNext.t('save')}
//               </FComponentsLib.FTextBtn>
//             </>
//           )}
//         </Space>
//       </div>

//       <div style={{ height: 20 }} />
//       {$isEdit && (
//         <div>
//           <FInput_PinyinSafeTextCounter_MultiLine
//             value={$value}
//             lengthLimit={200}
//             onChangeValue={(value) => {
//               set$value(value);
//             }}
//           />

//           {$valueError !== '' && (
//             <>
//               <div style={{ height: 5 }} />
//               <div style={{ color: '#EE4040' }}>{$valueError}</div>
//             </>
//           )}
//         </div>
//       )}

//       {!$isEdit && (
//         <>
//           {value !== '' ? (
//             <div className={styles.aboutPanel}>
//               <pre>{value}</pre>
//             </div>
//           ) : (
//             <div>
//               <div style={{ height: 10 }} />
//               <div
//                 style={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center',
//                   flexDirection: 'column',
//                 }}
//               >
//                 {tip.split('<br />').map((text, textIndex) => {
//                   return (
//                     <FComponentsLib.FContentText
//                       // text={FI18n.i18nNext.t('标题直接影响商品的搜索曝光机会，建议在标题中加入品牌/内容主旨，')}
//                       text={text}
//                       key={textIndex}
//                       type={'additional2'}
//                     />
//                   );
//                 })}

//                 <div style={{ height: 20 }} />
//                 <FComponentsLib.FRectBtn
//                   type='primary'
//                   onClick={() => {
//                     onEdit();
//                   }}
//                 >
//                   {/*添加展品简介*/}
//                   {btnText}
//                 </FComponentsLib.FRectBtn>
//               </div>
//               <div style={{ height: 20 }} />
//             </div>
//           )}
//         </>
//       )}
//     </div>
//   );
// }
